<template>
  <v-card class="baaderbank-confirm-trades">
    <v-card-title class="toolbar white--text">
      <h3>Trades ({{ filteredItems.length }})</h3>
      <div
        v-if="selected.length > 0"
        class="ml-3"
      >
        <v-menu offset-y>
          <template v-slot:activator="{ on: onMenu }">
            <v-tooltip top>
              <template v-slot:activator="{ on: onTooltip }">
                <v-btn
                  dark
                  flat
                  icon
                  v-on="{ ...onMenu, ...onTooltip }"
                >
                  <v-icon>pending_actions</v-icon>
                </v-btn>
              </template>

              <span>Update state</span>
            </v-tooltip>
          </template>

          <v-list>
            <v-list-tile
              v-for="(item, index) in updatableStates"
              :key="index"
              @click="validateUpdateTrades(item)"
            >
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>

      <v-spacer />
      <v-text-field
        v-model="search"
        primary
        dark
        solo-inverted
        flat
        append-icon="search"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filteredItems"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :search="search"
      :loading="loading"
      select-all
      item-key="id"
      class="elevation-1"
      @update:pagination="updatePagination"
    >
      <template v-slot:items="props">
        <tr
          :active="props.selected"
          @click="toogleOpened(props)"
        >
          <td>
            <v-checkbox
              :input-value="props.selected"
              color="primary"
              hide-details
              @click.stop="toogleSelected(props)"
            />
          </td>
          <td>
            {{ props.item.id }}
          </td>
          <td>
            {{ props.item.sell_offer_id }}
          </td>
          <td>
            {{ props.item.sell_offer.user_id }}
          </td>
          <td>
            {{ props.item.user_id }}
          </td>
          <td>
            {{ props.item.sell_offer.asset.title }}
          </td>
          <td>
            {{ props.item.sell_offer.security_wallet }}
          </td>
          <td>
            {{ formatField(props.item.state) }}
          </td>
          <td>
            <span class="price">{{ centsToEuros(props.item.total) }}</span>
          </td>
          <td class="text-xs-center">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="grey"
                  outline
                  small
                  v-on="on"
                >
                  <span>
                    {{ formatDateSmall(props.item.created_at) }}
                  </span>
                </v-chip>
              </template>
              {{ formatDate(props.item.created_at) }}
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="grey"
                  outline
                  small
                  v-on="on"
                >
                  <span>
                    {{ formatDateSmall(props.item.updated_at) }}
                  </span>
                </v-chip>
              </template>
              {{ formatDate(props.item.updated_at) }}
            </v-tooltip>
          </td>
        </tr>
      </template>

      <template v-slot:expand="props">
        <TradeDetail
          :item="props.item"
        />
      </template>
    </v-data-table>

    <v-dialog
      v-model="verifyUpdateModalOpen"
      width="600"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Confirm Trades state update.
        </v-card-title>
        <v-card-text v-if="canUpdateTrades">
          Update following ID(s) Trade(s) :
          <strong>{{ selected.map(select=> select.id).join(', ') }}</strong>
          <br>
          to state <strong v-if="updateTradeState">{{ updateTradeState.text }}</strong>.
        </v-card-text>
        <v-card-text v-else>
          The following trades cannot be updated to state
          <strong v-if="updateTradeState">{{ updateTradeState.text }}</strong>:
          <br>
          <div
            v-for="(trade, index) in invalidUpdateTrades"
            :key="index"
          >
            <strong>{{ trade.id }}</strong>  - State:
            <strong class="error--text">{{ trade.state }}</strong>
          </div>
        </v-card-text>
        <v-form
          ref="updateForm"
          @submit.prevent="updateTrades"
        >
          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="verifyUpdateModalOpen = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              text="Update Trades state"
              :loading="loading"
              :disabled="!canUpdateTrades"
              @click="updateTrades"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import { Button } from '@/components/shared';
import { setQuery } from '@/helpers';
import { tradeStates, closableStates, baaderTransitions } from '@/enum/trades/TradeStates';
import TradeDetail from '@/components/trades/shared/TradeDetail';


export default {
  name: 'BaaderbankConfirmTrades',
  components: {
    'e-button': Button,
    TradeDetail,
  },
  props: {
    trades: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      verifyUpdateModalOpen: false,
      isLoadTableData: false,
      search: '',
      selected: [],
      updateTradeState: null,
      errorMessage: '',
      invalidUpdateTrades: [],
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
        sortBy: 'createdAt',
        descending: true,
      },
      rowsPerPageItems: [
        {
          text: '10',
          value: 10,
        },
        {
          text: '25',
          value: 25,
        },
        {
          text: '50',
          value: 50,
        },
        {
          text: '100',
          value: 100,
        },
        {
          text: 'All',
          value: -1,
        },
      ],
      filters: {
        createdAt: [],
      },
      headers: [

        {
          text: 'Trade',
          align: 'left',
          value: 'id',
        },
        {
          text: 'Sell offer',
          align: 'left',
          value: 'sell_offer_id',
        },
        {
          text: 'Seller Id',
          align: 'left',
          value: 'sell_offer.user_id',
        },
        {
          text: 'Buyer Id',
          align: 'left',
          value: 'user_id',
        },
        {
          text: 'Project',
          value: 'sell_offer.asset.title',
        },
        {
          text: 'Security wallet',
          value: 'sell_offer.security_wallet',
        },
        {
          text: 'State',
          align: 'left',
          value: 'state',
        },
        {
          text: 'Total',
          align: 'left',
          value: 'total',
        },
        {
          text: 'Created at',
          value: 'created_at',
        },
        {
          text: 'Updated at',
          value: 'updated_at',
        },
      ],
    };
  },
  computed: {
    filteredItems() {
      return this.trades.filter(d => Object.keys(this.filters).every((f) => {
        if (this.filters[f]) {
          return (
            this.filters[f].length < 1 ||
            String(this.filters[f]).includes(d[f])
          );
        }

        return true;
      }));
    },
    tradeStates() {
      return tradeStates();
    },
    updatableStates() {
      return this.tradeStates.filter(state => this.baaderTransitions.includes(state.value));
    },

    closableStates() {
      return closableStates();
    },
    baaderTransitions() {
      return baaderTransitions();
    },
    canUpdateTrades() {
      return this.invalidUpdateTrades.length === 0;
    },
    canCloseTrades() {
      return this.invalidCloseTrades.length === 0;
    },
  },
  watch: {
    async trades() {
      this.getDefaultFilters();
      await this.$nextTick();
      await this.changePage();
    },
    search(val) {
      setQuery(
        {
          search: val,
        },
        this.$route,
        this.$router,
      );
    },
  },
  methods: {
    ...mapActions(['updateBaaderTradeState']),

    formatDate(date) {
      return this.$moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    formatDateSmall(date) {
      return this.$moment(date).format('DD/MM/YYYY');
    },
    centsToEuros(amount) {
      amount = `${parseInt(amount, 0) / 100}`;

      return `${parseFloat(amount).toFixed(2)} €`;
    },
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.trades.slice();
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    updatePagination(pagination) {
      if (this.isLoadTableData) {
        setQuery(
          {
            page: pagination.page,
          },
          this.$route,
          this.$router,
        );
      }
    },
    toogleSelected(props) {
      props.selected = !props.selected;
    },
    toogleOpened(props) {
      props.expanded = !props.expanded;
    },
    async changePage() {
      const { page, search } = this.$route.query;
      this.search = search;
      await this.$nextTick();
      this.isLoadTableData = true;
      this.pagination.page = page ? Number(page) : 1;
    },
    getDefaultFilters() {
      if (this.$route.query) {
        Object.keys(this.$route.query).forEach((item) => {
          let value = this.$route.query[item];

          if (Object.prototype.hasOwnProperty.call(this.filters, item)) {
            if (typeof this.filters[item] === 'string') {
              this.filters[item] = value;
            } else if (String(this.$route.query[item]).includes(';')) {
              value = this.$route.query[item].split(';');
              this.filters[item] = value;
            } else {
              this.filters[item].push(value);
            }
          }
        });
      }
    },

    validateUpdateTrades(state) {
      this.updateTradeState = state;
      this.invalidUpdateTrades = [];

      const data = { ids: this.selected.map(v => v.id) };

      data.ids.map((tradeId) => {
        const trade = this.trades.find(item => item.id === tradeId);

        if (!this.baaderTransitions.includes(trade.state)) {
          this.invalidUpdateTrades.push(trade);
        }

        return trade;
      });
      this.verifyUpdateModalOpen = true;
    },

    async updateTrades() {
      const data = { ids: this.selected.map(v => v.id), state: this.updateTradeState.value };

      await this.updateBaaderTradeState(data);

      this.verifyUpdateModalOpen = false;
      this.selected = [];
    },

    formatField(str, item) {
      if (str) {
        const camelCaseSentence = str.replace(/([-_]\w)/g, g => g[1].toUpperCase());
        const sentence = _.startCase(camelCaseSentence);

        if (item) {
          if (str === 'security_wallet' && item.sell_offer.asset.provider === 'baaderbank') {
            return `${_.capitalize(sentence)} / Baader Bank account`;
          }
        }

        return _.capitalize(sentence);
      }

      return '';
    },

    formatValue(value, key) {
      if (key === 'total' || key === 'unit_price') {
        return this.centsToEuros(value);
      }
      if (key.includes('_at')) {
        return this.formatDate(value);
      }

      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: black;
}

.toolbar {
  background-color: #1a4c7d;
  color: white;
}

.infoLabel {
  margin-left: 16px;
}

.countLabel {
  color: #fff;
}
.price {
  display:block;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/trades/BaaderbankConfirmTrades.vue